if (!customElements.get('media-gallery')) {
  class MediaGallery extends HTMLElement {
    constructor() {
      super();

      if (Shopify.designMode) {
        setTimeout(() => this.init(), 200);
      } else {
        this.init();
      }
    }

    disconnectedCallback() {
      window.removeEventListener('on:debounced-resize', this.resizeHandler);

      if (this.resizeInitHandler) {
        window.removeEventListener('on:debounced-resize', this.resizeInitHandler);
      }

      if (this.zoomInitHandler) {
        window.removeEventListener('on:debounced-resize', this.zoomInitHandler);
      }
    }

    init() {
      this.section = this.closest('.js-product');
      this.mediaGroupingEnabled = this.hasAttribute('data-media-grouping-enabled')
        && this.getMediaGroupData();
      this.stackedScroll = this.dataset.stackedScroll;
      this.stackedUnderline = this.dataset.stackedUnderline === 'true' && !this.mediaGroupingEnabled;
      this.isFeatured = this.dataset.isFeatured === 'true';
      this.viewer = this.querySelector('.media-viewer');
      this.thumbs = this.querySelector('.media-thumbs');
      this.thumbsItems = this.querySelectorAll('.media-thumbs__item');
      this.controls = this.querySelector('.media-ctrl');
      this.prevBtn = this.querySelector('.media-ctrl__btn[name="prev"]');
      this.nextBtn = this.querySelector('.media-ctrl__btn[name="next"]');
      this.counterCurrent = this.querySelector('.media-ctrl__current-item');
      this.counterTotal = this.querySelector('.media-ctrl__total-items');
      this.liveRegion = this.querySelector('.media-gallery__status');
      this.zoomLinks = this.querySelectorAll('.js-zoom-link');
      this.loadingSpinner = this.querySelector('.loading-spinner');
      this.xrButton = this.querySelector('.media-xr-button');


      const fullscreenButton = this.querySelector('.btn-image-fullscreen');

      if (fullscreenButton) {
        fullscreenButton.addEventListener('click', () => {
          // Find the parent element with class "video-container"
          const mediaContainer = fullscreenButton.closest('.product-media-container');
          if (mediaContainer) {
            mediaContainer.classList.toggle('fullscreen');
          }
        });
        // Listen for the Escape key to remove the "fullscreen" class
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') { // Check if the pressed key is "Escape"
            const mediaContainer = fullscreenButton.closest('.product-media-container');
            if (mediaContainer && mediaContainer.classList.contains('fullscreen')) {
              mediaContainer.classList.remove('fullscreen');
            }
          }
        });
      }

      const video = document.getElementById('video-product-detail');


      if (video) {
        // Play/Pause functionality
        const playPauseButton = document.getElementById('play-pause');
        const muteButton = document.getElementById('mute');
        const fullscreenButton = document.getElementById('fullscreen');
        const timeDisplay = document.getElementById('time-display');

        playPauseButton.addEventListener('click', () => {
          if (video.paused) {
            // Try to play the video
            var playPromise = video.play();
            playPauseButton.innerHTML = '<svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.2043 5.17629C11.2652 5.75324 11.2652 7.24677 10.2043 7.82371L3.79831 11.3073C2.76718 11.868 1.5 11.1382 1.5 9.98355L1.5 3.01645C1.5 1.86184 2.76718 1.13201 3.79831 1.69274L10.2043 5.17629Z" stroke="black"></path></svg>';

            if (playPromise !== undefined) {
              playPromise.then(() => {
                // Automatic playback started
                // Show playing UI (button change to pause icon)
                playPauseButton.innerHTML = '<svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.496643 2.88818C0.496643 2.30576 0.496643 2.01454 0.572764 1.78483C0.674258 1.47854 0.868932 1.2352 1.11396 1.10833C1.29773 1.01318 1.5307 1.01318 1.99664 1.01318C2.46258 1.01318 2.69556 1.01318 2.87933 1.10833C3.12435 1.2352 3.31903 1.47854 3.42052 1.78483C3.49664 2.01454 3.49664 2.30576 3.49664 2.88818V9.13818C3.49664 9.72061 3.49664 10.0118 3.42052 10.2415C3.31903 10.5478 3.12435 10.7912 2.87933 10.918C2.69556 11.0132 2.46258 11.0132 1.99664 11.0132C1.5307 11.0132 1.29773 11.0132 1.11396 10.918C0.868932 10.7912 0.674258 10.5478 0.572764 10.2415C0.496643 10.0118 0.496643 9.72061 0.496643 9.13818V2.88818Z" stroke="black"></path><path d="M6.49661 2.88818C6.49661 2.30576 6.49661 2.01454 6.57273 1.78483C6.67423 1.47854 6.8689 1.2352 7.11393 1.10833C7.2977 1.01318 7.53067 1.01318 7.99661 1.01318C8.46255 1.01318 8.69553 1.01318 8.8793 1.10833C9.12432 1.2352 9.319 1.47854 9.42049 1.78483C9.49661 2.01454 9.49661 2.30576 9.49661 2.88818V9.13818C9.49661 9.72061 9.49661 10.0118 9.42049 10.2415C9.319 10.5478 9.12432 10.7912 8.8793 10.918C8.69553 11.0132 8.46255 11.0132 7.99661 11.0132C7.53067 11.0132 7.2977 11.0132 7.11393 10.918C6.8689 10.7912 6.67423 10.5478 6.57273 10.2415C6.49661 10.0118 6.49661 9.72061 6.49661 9.13818V2.88818Z" stroke="black"></path></svg>';
              }).catch(error => {
                // Auto-play was prevented (could be due to browser policies)
                console.error('Auto-play was prevented:', error);
                // Show paused UI (button change to play icon)
                playPauseButton.innerHTML = '<svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.496643 2.88818C0.496643 2.30576 0.496643 2.01454 0.572764 1.78483C0.674258 1.47854 0.868932 1.2352 1.11396 1.10833C1.29773 1.01318 1.5307 1.01318 1.99664 1.01318C2.46258 1.01318 2.69556 1.01318 2.87933 1.10833C3.12435 1.2352 3.31903 1.47854 3.42052 1.78483C3.49664 2.01454 3.49664 2.30576 3.49664 2.88818V9.13818C3.49664 9.72061 3.49664 10.0118 3.42052 10.2415C3.31903 10.5478 3.12435 10.7912 2.87933 10.918C2.69556 11.0132 2.46258 11.0132 1.99664 11.0132C1.5307 11.0132 1.29773 11.0132 1.11396 10.918C0.868932 10.7912 0.674258 10.5478 0.572764 10.2415C0.496643 10.0118 0.496643 9.72061 0.496643 9.13818V2.88818Z" stroke="black"></path><path d="M6.49661 2.88818C6.49661 2.30576 6.49661 2.01454 6.57273 1.78483C6.67423 1.47854 6.8689 1.2352 7.11393 1.10833C7.2977 1.01318 7.53067 1.01318 7.99661 1.01318C8.46255 1.01318 8.69553 1.01318 8.8793 1.10833C9.12432 1.2352 9.319 1.47854 9.42049 1.78483C9.49661 2.01454 9.49661 2.30576 9.49661 2.88818V9.13818C9.49661 9.72061 9.49661 10.0118 9.42049 10.2415C9.319 10.5478 9.12432 10.7912 8.8793 10.918C8.69553 11.0132 8.46255 11.0132 7.99661 11.0132C7.53067 11.0132 7.2977 11.0132 7.11393 10.918C6.8689 10.7912 6.67423 10.5478 6.57273 10.2415C6.49661 10.0118 6.49661 9.72061 6.49661 9.13818V2.88818Z" stroke="black"></path></svg>';
              });
            }
          } else {
            // If the video is already playing, pause it.
            video.pause();
            playPauseButton.innerHTML = '<svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.2043 5.17629C11.2652 5.75324 11.2652 7.24677 10.2043 7.82371L3.79831 11.3073C2.76718 11.868 1.5 11.1382 1.5 9.98355L1.5 3.01645C1.5 1.86184 2.76718 1.13201 3.79831 1.69274L10.2043 5.17629Z" stroke="black"></path></svg>';
          }
        });


        // Mute/Unmute functionality
        muteButton.addEventListener('click', () => {
          video.muted = !video.muted;
          muteButton.innerHTML = video.muted ? '<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_12383_6144)"><path d="M9.07779 6.01332C9.07779 5.73718 8.85393 5.51332 8.57779 5.51332C8.30165 5.51332 8.07779 5.73718 8.07779 6.01332H9.07779ZM4.33589 3.49238L4.41915 3.9854L4.33589 3.49238ZM5.12745 3.12344L4.85222 2.70601L4.85222 2.70601L5.12745 3.12344ZM4.69176 3.38562L4.89364 3.84305L4.69176 3.38562ZM2.49773 8.37468L2.28778 8.82846L2.49773 8.37468ZM1.59518 6.52752L1.09611 6.55794L1.59518 6.52752ZM1.80706 7.72482L2.24723 7.48766L1.80706 7.72482ZM7.67782 10.0508L7.51633 9.57758L7.67782 10.0508ZM8.53415 7.31602L9.03361 7.33922L8.53415 7.31602ZM7.96764 9.9033L8.25513 10.3124L7.96764 9.9033ZM5.23692 3.05126L5.51215 3.46869L5.51215 3.46869L5.23692 3.05126ZM7.67782 1.97586L7.51633 2.44907L7.67782 1.97586ZM7.96764 2.12335L8.25513 1.71426V1.71426L7.96764 2.12335ZM2.49773 3.65197L2.28778 3.19818L2.49773 3.65197ZM1.59518 5.49912L1.09611 5.4687L1.59518 5.49912ZM1.80706 4.30182L2.24723 4.53899L1.80706 4.30182ZM5.85184 8.78149C5.62087 8.63014 5.31094 8.69468 5.15958 8.92565C5.00823 9.15662 5.07277 9.46655 5.30374 9.6179L5.85184 8.78149ZM5.40268 3.54087L5.51215 3.46869L4.96169 2.63383L4.85222 2.70601L5.40268 3.54087ZM2.09426 6.4971C2.08379 6.32539 2.07779 6.16174 2.07779 6.01332H1.07779C1.07779 6.18731 1.08478 6.37204 1.09611 6.55794L2.09426 6.4971ZM2.07779 6.01332C2.07779 5.86491 2.08379 5.70125 2.09426 5.52954L1.09611 5.4687C1.08478 5.65461 1.07779 5.83934 1.07779 6.01332H2.07779ZM8.07779 6.01332C8.07779 6.26586 8.06072 6.73264 8.03469 7.29281L9.03361 7.33922C9.0595 6.78212 9.07779 6.29267 9.07779 6.01332H8.07779ZM3.82783 4.01332C4.06757 4.01332 4.2443 4.01493 4.41915 3.9854L4.25263 2.99936C4.17947 3.01172 4.10016 3.01332 3.82783 3.01332V4.01332ZM4.85222 2.70601C4.62486 2.85591 4.55777 2.89823 4.48988 2.92819L4.89364 3.84305C5.05587 3.77146 5.20253 3.67283 5.40268 3.54087L4.85222 2.70601ZM4.41915 3.9854C4.5826 3.9578 4.74199 3.90998 4.89364 3.84305L4.48988 2.92819C4.41406 2.96165 4.33436 2.98556 4.25263 2.99936L4.41915 3.9854ZM3.82783 9.01332C4.10016 9.01332 4.17947 9.01493 4.25263 9.02728L4.41915 8.04124C4.2443 8.01172 4.06757 8.01332 3.82783 8.01332V9.01332ZM3.82783 8.01332C3.09437 8.01332 2.884 8.00247 2.70768 7.92089L2.28778 8.82846C2.71079 9.02418 3.18738 9.01332 3.82783 9.01332V8.01332ZM1.09611 6.55794C1.1307 7.12547 1.14697 7.55382 1.36689 7.96199L2.24723 7.48766C2.15392 7.31447 2.13335 7.13841 2.09426 6.4971L1.09611 6.55794ZM2.70768 7.92089C2.53204 7.83963 2.33903 7.65803 2.24723 7.48766L1.36689 7.96199C1.56128 8.32277 1.91584 8.65638 2.28778 8.82846L2.70768 7.92089ZM8.03469 7.29281C7.99895 8.06186 7.97345 8.5879 7.90552 8.96525C7.83801 9.34026 7.74768 9.44676 7.68014 9.49422L8.25513 10.3124C8.64895 10.0356 8.80682 9.60282 8.8897 9.14242C8.97216 8.68437 8.99924 8.07888 9.03361 7.33922L8.03469 7.29281ZM7.8393 10.524C7.98645 10.4738 8.12792 10.4018 8.25513 10.3124L7.68014 9.49422C7.63044 9.52915 7.57383 9.55796 7.51633 9.57758L7.8393 10.524ZM5.51215 3.46869C6.1601 3.04147 6.60455 2.74967 6.95252 2.58063C7.29919 2.41223 7.43917 2.42273 7.51633 2.44907L7.8393 1.50266C7.3828 1.34687 6.93807 1.47591 6.51557 1.68115C6.09438 1.88575 5.58522 2.22271 4.96169 2.63383L5.51215 3.46869ZM7.51633 2.44907C7.57383 2.46869 7.63044 2.4975 7.68014 2.53243L8.25513 1.71426C8.12792 1.62486 7.98645 1.55287 7.8393 1.50266L7.51633 2.44907ZM3.82783 3.01332C3.18738 3.01332 2.71079 3.00247 2.28778 3.19818L2.70768 4.10575C2.884 4.02417 3.09437 4.01332 3.82783 4.01332V3.01332ZM2.09426 5.52954C2.13335 4.88823 2.15392 4.71217 2.24723 4.53899L1.36689 4.06465C1.14697 4.47282 1.1307 4.90117 1.09611 5.4687L2.09426 5.52954ZM2.28778 3.19818C1.91584 3.37026 1.56128 3.70387 1.36689 4.06465L2.24723 4.53899C2.33903 4.36861 2.53204 4.18701 2.70768 4.10575L2.28778 3.19818ZM5.30374 9.6179C5.82147 9.95717 6.25994 10.2351 6.63744 10.4021C7.02115 10.5719 7.42524 10.6653 7.8393 10.524L7.51633 9.57758C7.44669 9.60134 7.32516 9.61286 7.04197 9.4876C6.75257 9.35958 6.38288 9.12948 5.85184 8.78149L5.30374 9.6179ZM9.01416 4.27715C8.98395 3.66555 8.95068 3.15211 8.86341 2.75158C8.77452 2.34365 8.61179 1.96492 8.25513 1.71426L7.68014 2.53243C7.74112 2.57528 7.82136 2.66629 7.88633 2.96448C7.95292 3.27007 7.98439 3.69911 8.01538 4.32649L9.01416 4.27715Z" fill="black"></path><path d="M10.8278 9.01316C10.8278 9.01316 11.5778 8.11316 11.5778 6.01316C11.5778 4.79647 11.326 3.98259 11.1142 3.51318" stroke="black" stroke-linecap="round"></path><path d="M9.82779 7.51318C9.82779 7.51318 10.0778 7.06318 10.0778 6.01318C10.0778 5.58224 10.0357 5.25236 9.98602 5.01318" stroke="black" stroke-linecap="round"></path><path d="M11.8278 1.01318L1.82779 11.0132" stroke="black" stroke-linecap="round"></path></g><defs><clipPath id="clip0_12383_6144"><rect width="12" height="12" fill="white" transform="translate(0.827789 0.0131836)"></rect></clipPath></defs></svg>' : '<svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.767395 5.98569C0.804234 5.38128 0.822653 5.07907 0.97927 4.78839C1.12236 4.52282 1.39615 4.26521 1.66994 4.13854C1.9696 3.99989 2.31308 3.99989 3.00004 3.99989C3.25608 3.99989 3.38409 3.99989 3.5081 3.97895C3.63069 3.95825 3.75023 3.92239 3.86397 3.87219C3.97903 3.82141 4.08591 3.75095 4.29966 3.61001L4.40913 3.53783C5.68061 2.69949 6.31636 2.28032 6.85003 2.46244C6.95235 2.49735 7.05139 2.54775 7.13985 2.60992C7.6012 2.93415 7.63625 3.6885 7.70636 5.1972C7.73232 5.75583 7.75 6.23395 7.75 6.49989C7.75 6.76584 7.73232 7.24395 7.70636 7.80259C7.63625 9.31129 7.6012 10.0656 7.13985 10.3899C7.05139 10.452 6.95235 10.5024 6.85003 10.5374C6.31636 10.7195 5.68061 10.3003 4.40913 9.46196L4.29966 9.38978C4.0859 9.24884 3.97903 9.17837 3.86397 9.1276C3.75023 9.0774 3.63069 9.04154 3.5081 9.02083C3.38409 8.99989 3.25608 8.99989 3.00004 8.99989C2.31308 8.99989 1.9696 8.99989 1.66994 8.86125C1.39615 8.73458 1.12236 8.47697 0.97927 8.2114C0.822653 7.92072 0.804234 7.61851 0.767395 7.01409C0.756496 6.83529 0.75 6.66109 0.75 6.49989C0.75 6.33869 0.756496 6.1645 0.767395 5.98569Z" stroke="black"></path><path d="M10 3.5C10 3.5 10.75 4.4 10.75 6.5C10.75 8.6 10 9.5 10 9.5" stroke="black" stroke-linecap="round"></path><path d="M9 5C9 5 9.25 5.45 9.25 6.5C9.25 7.55 9 8 9 8" stroke="black" stroke-linecap="round"></path></svg>';
        });

        // Update time display as the video plays
        video.addEventListener('timeupdate', () => {
          const currentTime = formatTime(video.currentTime);
          const duration = formatTime(video.duration || 0); // Handle case when duration is not yet available
          timeDisplay.textContent = `${currentTime}`;
        });

        // Update button icon based on video state
        function updateButtonIcon() {
          if (video.paused) {
            playPauseButton.innerHTML = '<svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.2043 5.17629C11.2652 5.75324 11.2652 7.24677 10.2043 7.82371L3.79831 11.3073C2.76718 11.868 1.5 11.1382 1.5 9.98355L1.5 3.01645C1.5 1.86184 2.76718 1.13201 3.79831 1.69274L10.2043 5.17629Z" stroke="black"></path></svg>';

          } else {
            playPauseButton.innerHTML = '<svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.496643 2.88818C0.496643 2.30576 0.496643 2.01454 0.572764 1.78483C0.674258 1.47854 0.868932 1.2352 1.11396 1.10833C1.29773 1.01318 1.5307 1.01318 1.99664 1.01318C2.46258 1.01318 2.69556 1.01318 2.87933 1.10833C3.12435 1.2352 3.31903 1.47854 3.42052 1.78483C3.49664 2.01454 3.49664 2.30576 3.49664 2.88818V9.13818C3.49664 9.72061 3.49664 10.0118 3.42052 10.2415C3.31903 10.5478 3.12435 10.7912 2.87933 10.918C2.69556 11.0132 2.46258 11.0132 1.99664 11.0132C1.5307 11.0132 1.29773 11.0132 1.11396 10.918C0.868932 10.7912 0.674258 10.5478 0.572764 10.2415C0.496643 10.0118 0.496643 9.72061 0.496643 9.13818V2.88818Z" stroke="black"></path><path d="M6.49661 2.88818C6.49661 2.30576 6.49661 2.01454 6.57273 1.78483C6.67423 1.47854 6.8689 1.2352 7.11393 1.10833C7.2977 1.01318 7.53067 1.01318 7.99661 1.01318C8.46255 1.01318 8.69553 1.01318 8.8793 1.10833C9.12432 1.2352 9.319 1.47854 9.42049 1.78483C9.49661 2.01454 9.49661 2.30576 9.49661 2.88818V9.13818C9.49661 9.72061 9.49661 10.0118 9.42049 10.2415C9.319 10.5478 9.12432 10.7912 8.8793 10.918C8.69553 11.0132 8.46255 11.0132 7.99661 11.0132C7.53067 11.0132 7.2977 11.0132 7.11393 10.918C6.8689 10.7912 6.67423 10.5478 6.57273 10.2415C6.49661 10.0118 6.49661 9.72061 6.49661 9.13818V2.88818Z" stroke="black"></path></svg>';
          }
        }

        if (window.innerWidth < 767) {
          // Listen for play and pause events
          video.addEventListener('play', updateButtonIcon);
          video.addEventListener('pause', updateButtonIcon);
        }

        // Fullscreen functionality for the container
        fullscreenButton.addEventListener('click', () => {
          const videoContainer = document.querySelector('.video-container');

          // Check if the screen is already in fullscreen mode
          if (!document.fullscreenElement && !document.webkitFullscreenElement) {
            if (window.innerWidth < 767) {
              // Enter fullscreen
              if (video.requestFullscreen) {
                video.requestFullscreen().catch((err) => {
                  console.error(`Error entering fullscreen: ${err.message}`);
                });
              } else if (video.webkitRequestFullscreen) { // For Safari
                video.webkitRequestFullscreen().catch((err) => {
                  console.error(`Error entering fullscreen: ${err.message}`);
                });
              }
              if (video.webkitSupportsFullscreen) {
                video.webkitEnterFullscreen();
                return;
              }
            } else {
              // Enter fullscreen
              if (videoContainer.requestFullscreen) {
                videoContainer.requestFullscreen().catch((err) => {
                  console.error(`Error entering fullscreen: ${err.message}`);
                });
              } else if (videoContainer.webkitRequestFullscreen) { // For Safari
                videoContainer.webkitRequestFullscreen().catch((err) => {
                  console.error(`Error entering fullscreen: ${err.message}`);
                });
              }
            }

          } else {
            // Exit fullscreen
            if (document.exitFullscreen) {
              document.exitFullscreen();
            } else if (document.webkitExitFullscreen) { // For Safari
              document.webkitExitFullscreen();
            }
          }

        });

        // Add/remove fullscreen styles dynamically
        document.addEventListener('fullscreenchange', () => {
          if (document.fullscreenElement) {
            document.querySelector('.video-container').classList.add('fullscreen-active');
          } else {
            document.querySelector('.video-container').classList.remove('fullscreen-active');
          }
        });

        // Function to format time in MM:SS format
        function formatTime(time) {
          const minutes = Math.floor(time / 60);
          const seconds = Math.floor(time % 60);
          return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        }
      }



      if (this.mediaGroupingEnabled) {
        this.setActiveMediaGroup(this.getMediaGroupFromOptionSelectors());
      }

      if (this.dataset.layout === 'stacked' && theme.mediaMatches.md) {
        this.resizeInitHandler = this.resizeInitHandler || this.initGallery.bind(this);
        window.addEventListener('on:debounced-resize', this.resizeInitHandler);
        this.setVisibleItems();
        this.previousMediaItem = this.querySelector('.media-viewer__item.is-current-variant');
        setTimeout(() => this.customSetActiveMedia(this.previousMediaItem, this.stackedScroll === 'always'), 200);
      } else {
        this.initGallery();
      }

      if (this.zoomLinks) {
        this.zoomInitHandler = this.zoomInitHandler || this.initZoom.bind(this);
        this.zoomEventListener = this.zoomEventListener || this.handleZoomMouseMove.bind(this);
        window.addEventListener('on:debounced-resize', this.zoomInitHandler);
        this.initZoom();
        this.zoomLinks.forEach((el) => {
          el.addEventListener('click', (evt) => {
            evt.preventDefault();
          });
        });
      }

      this.section.addEventListener('on:variant:change', this.onVariantChange.bind(this));
    }

    /**
     * Handle a change in variant on the page.
     * @param {Event} evt - variant change event dispatched by variant-picker
     */
    onVariantChange(evt) {
      if (this.mediaGroupingEnabled) {
        this.setActiveMediaGroup(this.getMediaGroupFromOptionSelectors());
      }

      if (evt.detail.variant && evt.detail.variant.featured_media) {
        const variantMedia = this.viewer.querySelector(
          `[data-media-id="${evt.detail.variant.featured_media.id}"]`
        );
        this.customSetActiveMedia(variantMedia, true);
      }
    }

    /**
     * Gets the media group from currently selected variant options.
     * @returns {?object}
     */
    getMediaGroupFromOptionSelectors() {
      const optionSelectors = this.section.querySelectorAll('.option-selector');
      if (optionSelectors.length > this.getMediaGroupData().groupOptionIndex) {
        const selector = optionSelectors[this.getMediaGroupData().groupOptionIndex];
        if (selector.dataset.selectorType === 'dropdown') {
          return selector.querySelector('.custom-select__btn').textContent.trim();
        }
        return selector.querySelector('input:checked').value;
      }
      return null;
    }

    /**
     * Gets the variant media associations for a product.
     * @returns {?object}
     */
    getMediaGroupData() {
      if (typeof this.variantMediaData === 'undefined') {
        const dataEl = this.querySelector('.js-data-variant-media');
        this.variantMediaData = dataEl ? JSON.parse(dataEl.textContent) : false;
      }

      return this.variantMediaData;
    }

    /**
     * Gets an object mapping media to groups, and the reverse
     * @returns {?object}
     */
    getMediaGroupMap() {
      if (!this.mediaGroupMap) {
        this.mediaGroupMap = {
          groups: {}
        };

        // set up grouping
        const variantMediaData = this.getMediaGroupData();
        let currentMediaOptionName = false;
        this.viewerItems = this.querySelectorAll('.media-viewer__item');
        this.viewerItems.forEach((item) => {
          for (let i = 0; i < variantMediaData.variantMedia.length; i += 1) {
            if (parseInt(item.dataset.mediaId, 10) === variantMediaData.variantMedia[i].mediaId) {
              if (currentMediaOptionName !== variantMediaData.variantMedia[i].option) {
                currentMediaOptionName = variantMediaData.variantMedia[i].option;
              }
            }
          }
          if (currentMediaOptionName) {
            if (!this.mediaGroupMap.groups[currentMediaOptionName]) {
              this.mediaGroupMap.groups[currentMediaOptionName] = {
                name: currentMediaOptionName,
                items: []
              };
            }
            const groupItem = { main: item };
            if (this.thumbs) {
              groupItem.thumb = this.thumbs.querySelector(
                `[data-media-id="${item.dataset.mediaId}"].media-thumbs__item`
              );
            }
            this.mediaGroupMap.groups[currentMediaOptionName].items.push(groupItem);
          }
        });

        // add helper
        this.mediaGroupMap.groupFromItem = (item) => {
          const groups = Object.keys(this.mediaGroupMap.groups);
          for (let i = 0; i < groups; i += 1) {
            const group = groups[i];
            for (let j = 0; j < this.mediaGroupMap.groups[group].items.length; j += 1) {
              if (this.mediaGroupMap.groups[group].items[j] === item) {
                return this.mediaGroupMap.groups[group];
              }
            }
          }
          return this.mediaGroupMap.groups[Object.keys(this.mediaGroupMap.groups)[0]];
        };
      }

      return this.mediaGroupMap;
    }

    /**
     * Show only images associated to the current variant
     * @param {string} groupName - optional - Group to show (uses this.currentItem if empty)
     */
    setActiveMediaGroup(groupName) {
      const mediaGroupMap = this.getMediaGroupMap();
      const selectedGroup = groupName
        ? mediaGroupMap.groups[groupName]
        : mediaGroupMap.groupFromItem(this.currentItem);

      if (selectedGroup) {
        if (this.currentGroup !== selectedGroup) {
          this.currentGroup = selectedGroup;
          this.viewerItems.forEach((item) => {
            item.style.display = 'none';
            item.classList.remove('media-viewer__item--single');
          });
          this.thumbsItems.forEach((item) => {
            item.style.display = 'none';
          });

          let currentItemIsVisible = false;
          selectedGroup.items.forEach((item) => {
            item.main.style.display = '';
            if (item.thumb) {
              item.thumb.style.display = '';
            }
            if (item.main === this.currentItem) {
              currentItemIsVisible = true;
            }
          });
          this.setVisibleItems();

          // If current item is not in this group, set it as the active item
          if (!currentItemIsVisible) {
            this.customSetActiveMedia(selectedGroup.items[0].main, true);
          }

          // Handle single images on stacked view
          if (selectedGroup.items.length === 1) {
            selectedGroup.items[0].main.classList.add('media-viewer__item--single');
          }
        }
      } else {
        this.viewerItems.forEach((item) => {
          item.style.display = '';
        });
        this.thumbsItems.forEach((item) => {
          item.style.display = '';
        });
      }
    }

    /**
     * Initialises the media gallery slider and associated controls.
     */
    initGallery() {
      this.setVisibleItems();
      if (this.visibleItems.length <= 1) return;

      this.viewerItemOffset = this.visibleItems[1].offsetLeft - this.visibleItems[0].offsetLeft;
      this.currentIndex = Math.round(this.viewer.scrollLeft / this.viewerItemOffset);
      this.currentItem = this.visibleItems[this.currentIndex];
      this.addListeners();

      if (this.thumbs && this.currentItem) {
        this.currentThumb = this.thumbs.querySelector(
          `[data-media-id="${this.currentItem.dataset.mediaId}"]`
        );
      }

      if (!this.isFeatured && document.hasFocus()) {
        // Eager load the slider images for smooth UX
        this.viewer.querySelectorAll('.product-image[loading="lazy"]').forEach((img, index) => {
          setTimeout(() => {
            img.loading = 'eager';
          }, 500 * (index + 1));
        });
      }

      const currentItem = this.querySelector('.media-viewer__item.is-current-variant');
      this.customSetActiveMedia(currentItem, true);
    }

    addListeners() {
      this.viewer.addEventListener('scroll', this.handleScroll.bind(this));
      if (this.controls) this.controls.addEventListener('click', this.handleNavClick.bind(this));
      if (this.thumbs) this.thumbs.addEventListener('click', this.handleThumbClick.bind(this));
      this.resizeHandler = this.resizeHandler || this.handleResize.bind(this);
      window.addEventListener('on:debounced-resize', this.resizeHandler);
    }

    /**
     * Initialized the zoom on hover for desktop
     */
    initZoom() {
      this.zoomLinks.forEach((el) => {
        const zoomWidth = Number(el.querySelector('.zoom-image').dataset.originalWidth || 0);
        const imageWidth = el.querySelector('.product-image').getBoundingClientRect().width;
        if (theme.mediaMatches.md && ((zoomWidth - 75) > (imageWidth))) {
          el.addEventListener('mousemove', this.zoomEventListener);
          el.classList.remove('pointer-events-none');
        } else {
          el.removeEventListener('mousemove', this.zoomEventListener);
          el.classList.add('pointer-events-none');
        }
      });
    }

    /**
     * Handles mouse move over a zoomable image
     * @param {?object} evt - Event object.
     */
    handleZoomMouseMove(evt) {
      const hoverElem = evt.currentTarget;
      const zoomImage = hoverElem.querySelector('.js-zoom-image');

      // Download the zoom image if necessary
      if (zoomImage.dataset.src) {
        this.loadingSpinner.classList.remove('loading-spinner--out');

        const img = new Image();
        img.src = zoomImage.dataset.src;
        img.onload = () => {
          zoomImage.src = img.src;
          hoverElem.classList.remove('media--zoom-not-loaded');
          this.loadingSpinner.classList.add('loading-spinner--out');
        };
        zoomImage.removeAttribute('data-src');
      }

      try {
        const offsetX = evt.offsetX ? evt.offsetX : evt.touches[0].pageX;
        const offsetY = evt.offsetY ? evt.offsetY : evt.touches[0].pageY;
        const x = (offsetX / zoomImage.offsetWidth) * 100;
        const y = (offsetY / zoomImage.offsetHeight) * 100;
        zoomImage.style.objectPosition = `${x}% ${y}%`;
      } catch (err) {
        // Fail silently
      }
    }

    /**
     * Handles 'scroll' events on the main media container.
     */
    handleScroll() {
      const newIndex = Math.round(this.viewer.scrollLeft / this.viewerItemOffset);

      if (newIndex !== this.currentIndex) {
        const viewerItemOffset = this.visibleItems[1].offsetLeft - this.visibleItems[0].offsetLeft;

        // If scroll wasn't caused by a resize event, update the active media.
        if (viewerItemOffset === this.viewerItemOffset) {
          this.customSetActiveMedia(this.visibleItems[newIndex], false);
        }
      }
    }

    /**
     * Handles 'click' events on the controls container.
     * @param {object} evt - Event object.
     */
    handleNavClick(evt) {
      if (!evt.target.matches('.media-ctrl__btn')) return;

      const itemToShow = evt.target === this.nextBtn
        ? this.visibleItems[this.currentIndex + 1]
        : this.visibleItems[this.currentIndex - 1];

      this.viewer.scrollTo({ left: itemToShow.offsetLeft, behavior: 'smooth' });
    }

    /**
     * Handles 'click' events on the thumbnails container.
     * @param {object} evt - Event object.
     */
    handleThumbClick(evt) {
      const thumb = evt.target.closest('[data-media-id]');
      if (!thumb) return;

      const itemToShow = this.querySelector(`[data-media-id="${thumb.dataset.mediaId}"]`);
      this.customSetActiveMedia(itemToShow);

      MediaGallery.playActiveMedia(itemToShow);
    }

    /**
     * Handles debounced 'resize' events on the window.
     */
    handleResize() {
      // Reset distance from leading edge of one slide to the next.
      this.viewerItemOffset = this.visibleItems[1].offsetLeft - this.visibleItems[0].offsetLeft;

      if (this.thumbs && this.currentThumb) {
        this.checkThumbVisibilty(this.currentThumb);
      }
    }

    /**
     * Stub for variant-picker calls. Listening to change event instead.
     */
    // eslint-disable-next-line class-methods-use-this
    setActiveMedia() {}

    /**
     * Sets the active media item.
     * @param {Element} mediaItem - Media element to set as active.
     * @param {boolean} [scrollToItem=true] - Scroll to the active media item.
     */
    customSetActiveMedia(mediaItem, scrollToItem = true) {
      if (mediaItem === this.currentItem) return;
      window.pauseAllMedia(this);
      this.currentItem = mediaItem;
      this.currentIndex = this.visibleItems.indexOf(this.currentItem);

      if (this.dataset.layout === 'stacked' && theme.mediaMatches.md) {
        // Update the active class and scroll to the active media
        if (this.stackedUnderline) {
          if (this.previousMediaItem) this.previousMediaItem.classList.remove('is-active');
          mediaItem.classList.add('is-active');
          this.previousMediaItem = mediaItem;
        }

        if (this.stackedScroll !== 'never') {
          const y = mediaItem.getBoundingClientRect().top
            + document.documentElement.scrollTop - 150;

          // If the element is far enough away to scroll to it
          if (Math.abs(y - document.documentElement.scrollTop) > 300) {
            window.scrollTo({
              top: y < 100 ? 0 : y,
              behavior: 'smooth'
            });
          }
        }
        return;
      }

      if (scrollToItem) this.viewer.scrollTo({ left: this.currentItem.offsetLeft });
      if (this.thumbs) this.setActiveThumb();

      if (this.controls) {
        if (this.prevBtn) {
          this.prevBtn.disabled = this.currentIndex === 0;
        }

        if (this.nextBtn) {
          this.nextBtn.disabled = this.currentIndex === this.visibleItems.length - 1;
        }

        if (this.counterCurrent) {
          this.counterCurrent.textContent = this.currentIndex + 1;
        }
      }

      this.announceLiveRegion(this.currentItem, this.currentIndex + 1);

      if (this.xrButton && mediaItem.dataset.mediaType === 'model') {
        this.xrButton.dataset.shopifyModel3dId = mediaItem.dataset.mediaId;
      }
    }

    /**
     * Sets the active thumbnail.
     */
    setActiveThumb() {
      this.currentThumb = this.thumbs.querySelector(
        `[data-media-id="${this.currentItem.dataset.mediaId}"]`
      );
      const btn = this.currentThumb.querySelector('button');

      this.thumbs.querySelectorAll('.media-thumbs__btn').forEach((el) => {
        el.classList.remove('is-active');
        el.removeAttribute('aria-current');
      });

      btn.classList.add('is-active');
      btn.setAttribute('aria-current', 'true');
      this.checkThumbVisibilty(this.currentThumb);
    }

    /**
     * Creates an array of the visible media items.
     */
    setVisibleItems() {
      this.viewerItems = this.querySelectorAll('.media-viewer__item');
      this.visibleItems = Array.from(this.viewerItems).filter((el) => el.clientWidth > 0);
      if (this.counterTotal) {
        this.counterTotal.textContent = this.visibleItems.length;
      }
    }

    /**
     * Ensures a thumbnail is in the visible area of the slider.
     * @param {Element} thumb - Thumb item element.
     */
    checkThumbVisibilty(thumb) {
      const scrollPos = this.thumbs.scrollLeft;
      const lastVisibleThumbOffset = this.thumbs.clientWidth + scrollPos;
      const thumbOffset = thumb.offsetLeft;

      if (thumbOffset + thumb.clientWidth > lastVisibleThumbOffset || thumbOffset < scrollPos) {
        this.thumbs.scrollTo({ left: thumbOffset, behavior: 'smooth' });
      }
    }

    /**
     * Updates the media gallery status.
     * @param {Element} mediaItem - Active media element.
     * @param {number} index - Active media index.
     */
    announceLiveRegion(mediaItem, index) {
      const image = mediaItem.querySelector('.media-viewer img');
      if (!image) return;

      this.liveRegion.setAttribute('aria-hidden', 'false');
      this.liveRegion.innerHTML = theme.strings.imageAvailable.replace('[index]', index);

      setTimeout(() => {
        this.liveRegion.setAttribute('aria-hidden', 'true');
      }, 2000);
    }

    /**
     * Loads the deferred media for the active item.
     * @param {Element} mediaItem - Active media element.
     */
    static playActiveMedia(mediaItem) {
      window.pauseAllMedia();
      const deferredMedia = mediaItem.querySelector('deferred-media');
      if (deferredMedia) deferredMedia.loadContent();
    }
  }

  customElements.define('media-gallery', MediaGallery);
}
